import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';


import {
    fetchDiagramsList,
    toggleDiagramCreate,
    toggleDiagramImportSql,
} from '../../../redux/main/main.actions';
import {
    selectDiagramsList,
} from '../../../redux/main/main.selectors';

import Notify from '../../../components/Notify/Notify';
import ModalProfileMenu from '../../../components/Modals/ModalProfileMenu/ModalProfileMenu';

import ModalPricingPlanLimit from '../../../components/Modals/ModalPricingPlanLimit/ModalPricingPlanLimit';
import ModalPricingPlanUpgrade from '../../../components/Modals/ModalPricingPlanUpgrade/ModalPricingPlanUpgrade';

import ModalInviteToApp from '../../../components/Modals/ModalInvitePeople/ModalInvitePeople';
import ModalFeedbackThanks from '../../../components/Modals/ModalFeedbackThanks/ModalFeedbackThanks';

import ModalDiagramCreate from '../../../components/Modals/ModalDiagramCreate/ModalDiagramCreate';
import ModalDiagramImportSql from '../../../components/Modals/ModalDiagramImportSql/ModalDiagramImportSql';

import ModalDiagramClone from '../../../components/Modals/ModalDiagramClone/ModalDiagramClone';
import ModalDiagramRename from '../../../components/Modals/ModalDiagramRename/ModalDiagramRename';
import ModalDiagramDelete from '../../../components/Modals/ModalDiagramDelete/ModalDiagramDelete';

import ModalDiagramDetails from '../../../components/Modals/ModalDiagramDetails/ModalDiagramDetails';

import Sidebar from '../_components/Sidebar/Sidebar';
import Header from '../_components/Header/Header';

import ButtonImportSql from '../_components/ButtonImportSql/ButtonImportSql';
import DiagramGrid from '../_components/DiagramGrid/DiagramGrid';

import '../MainApp.scss';
import './Dashboard.scss';
import ModalDiagramCreateNew from '../../../components/Modals/ModalDiagramCreateNew/ModalDiagramCreateNew';
import ModalDiagramShare from '../../../components/Modals/ModalDiagramShare/ModalDiagramShare';
import ModalDiagramDeleteSoft from '../../../components/Modals/ModalDiagramDeleteSoft/ModalDiagramDeleteSoft';
import ModalDiagramRestore from '../../../components/Modals/ModalDiagramRestore/ModalDiagramRestore';

function filterData(data = null, type = 'all') {
    if (!data || !Array.isArray(data)) {
        return null;
    }

    return (data.filter((diagram) => (
        type === 'all' && !diagram.archived ||
        type === 'mydiagrams' && diagram.access_role === 'own' && !diagram.archived ||
        type === 'shared' && diagram.access_role !== 'own' ||
        type === 'archived' && diagram.archived
    )))
}

const Dashboard = () => {
    document.title = 'Diagrams | DB Design';

    const dispatch = useDispatch();
    const history = useHistory();

    const [selectedType, setSelectedType] = useState('all');

    const diagramsRedux = useSelector(selectDiagramsList);


    const [diagrams, setDiagrams] = useState(null);

    useEffect(() => {
        if (!filterData(diagramsRedux, 'archived')?.length && selectedType === 'archived') {
            setSelectedType('all');
        }

        setDiagrams(diagramsRedux);
    }, [diagramsRedux]);

    const handleCreateDiagram = () => {
        dispatch(toggleDiagramCreate());
    };
    const handleImportSql = () => {
        dispatch(toggleDiagramImportSql('sql'));
    };
    const handleImportDbml = () => {
        dispatch(toggleDiagramImportSql('dbml'));
    };

    useEffect(() => {
        dispatch(fetchDiagramsList());
    }, [dispatch]);

    const handleSelectType = (value) => {
        setSelectedType(value);
    };

    return (
        <div className="dash-container Dashboard">
            <Sidebar />
            <div className='dash-main'>

                {/* common modals */}
                <Notify viewType='main' />
                <ModalProfileMenu />

                <ModalPricingPlanLimit />
                <ModalPricingPlanUpgrade />

                <ModalInviteToApp />
                <ModalFeedbackThanks />

                {/* page components */}
                <ModalDiagramCreate />
                <ModalDiagramCreateNew />
                <ModalDiagramImportSql />

                <ModalDiagramClone />
                <ModalDiagramRename />
                <ModalDiagramShare />

                <ModalDiagramDeleteSoft />
                <ModalDiagramDelete />
                <ModalDiagramRestore />

                <ModalDiagramDetails />

                <Header title=''>
                    <ButtonImportSql handleSqlClick={(e) => { handleImportSql(e); }} handleDbmlClick={(e) => { handleImportDbml(e); }} />
                    <button className='dash-main-header-button prime' onClick={(e) => { handleCreateDiagram(e); }}>Create Diagram</button>
                </Header>

                <div className='dash-main-body'>

                    {/* diagrams */}
                    {/* <div className='dash-main-body-title'>Diagrams
                        <span>({filterData(diagrams, selectedType)?.length || 0})</span>
                    </div> */}

                    <div className='selection-group'>
                        <div className={`selection-item ${selectedType === 'all' ? 'selected' : ''}`} onClick={() => handleSelectType('all')}>All</div>
                        <div className={`selection-item ${selectedType === 'mydiagrams' ? 'selected' : ''}`} onClick={() => handleSelectType('mydiagrams')}>My diagrams</div>
                        <div className={`selection-item ${selectedType === 'shared' ? 'selected' : ''}`} onClick={() => handleSelectType('shared')}>Shared with me</div>
                        {filterData(diagrams, 'archived')?.length ?
                            <React.Fragment>
                                <div className="selection-item-slash"></div>
                                <div className={`selection-item ${selectedType === 'archived' ? 'selected' : ''}`} onClick={() => handleSelectType('archived')}>Archived diagrams</div>
                            </React.Fragment>
                            : ''}
                    </div>

                    {/* <div className='dash-main-body-title'>
                        My diagrams
                        <span>({templates?.length || 0})</span>
                        <span className='button' onClick={(e) => {
                            setTimeout(() => { history.push('/templates/'); }, 100);
                        }}>New Diagram</span>
                    </div> */}

                    <div className="diagrams-group">
                        {filterData(diagrams, selectedType)?.map((diagram) => <DiagramGrid key={diagram.id} data={diagram} />) || ''}
                    </div>

                    {/* shared diagrams */}
                    {/* <div className='dash-main-body-title'>Shared with me <span>({sharedDiagrams?.length || 0})</span></div>
                    {sharedDiagrams?.length ?
                        <div className="diagrams-group">
                            {sharedDiagrams.map((diagram) => <DiagramGrid data={diagram} />)}
                        </div>
                        : ''
                    } */}

                    {/* templates */}
                    {/* <div className='dash-main-body-title'>
                        Templates
                        <span>({templates?.length || 0})</span>
                        <span className='button' onClick={(e) => {
                            setTimeout(() => { history.push('/templates/'); }, 100);
                        }}>See more</span>
                    </div>
                    <div className="diagrams-group">
                        {templates.map((template) => <TemplateGrid data={template} />)}
                    </div> */}

                </div>

            </div>
        </div>
    );
};

export default Dashboard;
